import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchTimesheets, fetchTimesheetSummary } from '../../../states/actions'
import { PayrollMenu } from '../../../constants'
import { formatter, localStorage } from '../../../util'
import debounce from 'lodash.debounce'

// UI
import { ControlLabel, Page, Pager, SearchInput, List } from '../../../components'
import notify from '../../../components/Notification'
import Col from 'antd/lib/col'
import Icon from 'antd/lib/icon'
import Radio from 'antd/lib/radio'
import Row from 'antd/lib/row'
import Skeleton from 'antd/lib/skeleton'

import './styles.css'

const pageSize = 30

export class Payroll extends Component {
  constructor (props) {
    super(props)
    const { timesheets: { list, total }, loading } = props
    this.state = {
      employeeIds: [],
      currentPage: 1,
      filter: {},
      list,
      loading,
      searching: false,
      searchText: '',
      sort: {},
      total
    }
    this.onSearch = debounce(this.onSearch, 500)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { timesheets: { list, total }, timesheetSummary: { date_from, date_to, employees, clients, kms, sleepovers, hours, jobs, review, approved }, loading } = nextProps
    const state = { ...prevState, employees, clients, loading, kms, sleepovers, hours, jobs, review, approved, date_from, date_to }
    if (list !== prevState.list) {
      state.searching = false
    }
    state.list = list
    state.total = total
    return state
  }

  componentDidMount () {
    const { match } = this.props
    const { params } = match
    const { id } = params

    const filter = { id }
    const { currentPage, loading, searchText, sort } = this.state

    this.fetchTimesheetSummary()
    this.fetchTimesheets({ currentPage, filter, loading, searchText, sort })
    this.setState({ filter })
  }

  onSearch (value) {
    const { filter, loading, sort } = this.state
    this.setState({ searching: true })
    this.fetchTimesheets({ currentPage: 1, filter, loading, searchText: value, sort })
    this.setState({ searchText: value, currentPage: 1 })
  }

  onChangeView (event) {
    const value = event.target.value
    localStorage.setItem('timesheetView', value)

    this.setState({ list: [], total: 0 })
    const { filter, sort, searchText } = this.state

    this.fetchTimesheetSummary()
    this.fetchTimesheets({ currentPage: 1, filter, loading: true, searchText, sort })
  }

  onFilter (event) {
    const { filter, loading, sort, searchText } = this.state
    const value = event.target.value

    // delete filter.approved
    delete filter.review

    if (value !== 'all') {
      if (value === 'approved') {
        filter.review = { condition: '=', value: '0' }
      } else {
        filter.review = { condition: '>', value: '0' }
      }
    }

    this.fetchTimesheets({ currentPage: 1, filter, loading: true, searchText, sort })
    this.setState({ filter })
  }

  getTimesheetView () {
    return localStorage.getItem('timesheetView') || 'client'
  }

  isEmployeeView () {
    return this.getTimesheetView() === 'employee'
  }

  render () {
    const { filter, currentPage, list, date_from, date_to, employees = 0, clients = 0, loading, jobs = 0, total = 0, kms = 0, hours = 0, sleepovers = 0, approved = 0, review = 0, searching } = this.state

    const columns = [

      this.isEmployeeView() ? {
        title: 'Employees',
        width: 6,
        render: ({ employee, employee_id, employee_leave_id, employee_leave_start, employee_leave_end }) => employee_leave_id ? <div><a href={`/employees/${employee_id}`} target='_blank'><span style={{ fontWeight: 'bold' }}><Icon type='user' /> {employee}</span></a>&nbsp;
          <div style={{ color: '#ff0000', fontSize: '8.5pt' }}><Icon type='exclamation-circle' theme='twoTone' twoToneColor='#ff0000' />{` Leave ${formatter.toShortDate(employee_leave_start)} - ${formatter.toShortDate(employee_leave_end)}`}</div>
        </div> : <a href={`/employees/${employee_id}`} target='_blank'><span style={{ fontWeight: 'bold' }}><Icon type='user' /> {employee}</span></a>
      } : {
        title: 'Participants',
        width: 6,
        render: ({ client, client_id, client_leave_id, client_leave_start, client_leave_end }) => client_leave_id ? <div><a href={`/clients/${client_id}`} target='_blank'><span style={{ fontWeight: 'bold' }}><Icon type='user' /> {client}</span></a>&nbsp;
          <div style={{ color: '#ff0000', fontSize: '8.5pt' }}><Icon type='exclamation-circle' theme='twoTone' twoToneColor='#ff0000' />{` Leave ${formatter.toShortDate(client_leave_start)} - ${formatter.toShortDate(client_leave_end)}`}</div>
        </div> : <a href={`/clients/${client_id}`} target='_blank'><span style={{ fontWeight: 'bold' }}><Icon type='user' /> {client}</span></a>
      },
      {
        title: 'Jobs',
        width: 4,
        render: ({ jobs }) => <div style={{ color: '#1a63b0', fontWeight: 'bold' }}>{jobs}</div>
      },
      {
        title: 'Approved',
        width: 4,
        render: ({ approved }) => <div style={{ color: approved > 0 ? '#4fbc85' : '#aaa' }}>{approved}</div>
      },
      {
        title: 'To Review',
        width: 4,
        render: ({ review }) => <div style={{ color: review > 0 ? '#f50' : '#aaa' }}>{review}</div>
      },
      {
        title: 'Hours',
        width: 4,
        render: ({ hours }) => formatter.round(hours) || 0
      },
      // {
      //   title: 'Sleepovers',
      //   width: 3,
      //   render: ({ sleepovers }) => sleepovers || 0
      // },
      // {
      //   title: 'KMs',
      //   width: 2,
      //   render: ({ kms }) => kms || 0
      // },
      this.isEmployeeView() ? {
        title: '',
        width: 1,
        render: ({ id, employee_id }) => <Link to={`/billings/${id}/employee/${employee_id}`} className='button'><Icon type='form' /></Link>
      } : {
        title: '',
        width: 1,
        render: ({ id, client_id }) => <Link to={`/billings/${id}/client/${client_id}`} className='button'><Icon type='form' /></Link>
      }
    ]

    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Billings' menu={PayrollMenu} />
        </Page.Left>
        <Page.Content full>
          <Page.Header icon={<Icon type='table' />} title='Timesheet' total={`${formatter.toShortDate(date_from)} - ${formatter.toShortDate(date_to)}`}>
            <div className='btn' onClick={() => window.open(`/print/payroll/${filter.id}`)}>Print</div>
          </Page.Header>

          <div className='page-summary'>
            <Row>
              {
                this.isEmployeeView() ? (
                  <Col lg={6} className='col'>
                    <div className='number'>{employees}</div>
                  Employees
                  </Col>)
                  : (
                    <Col lg={6} className='col'>
                      <div className='number'>{clients}</div>
                      Participants
                    </Col>
                  )
              }
              <Col lg={4} className='col'>
                <div className='number'>{jobs}</div>
                Jobs
              </Col>
              <Col lg={4} className='col'>
                <div className='number'>{approved}</div>
                Approved
              </Col>
              <Col lg={4} className='col'>
                <div className='number'>{review}</div>
                To Review
              </Col>
              <Col lg={4} className='col'>
                <div className='number'>{ formatter.toDecimal(hours) }</div>
                Hours
              </Col>
              {/* <Col lg={3} className='col'>
                <div className='number'>{sleepovers || 0}</div>
                Sleepovers
              </Col>
              <Col lg={3} className='col'>
                <div className='number'>{kms}</div>
                KMs
              </Col> */}
            </Row>
          </div>

          <Page.Filter>
            <Row gutter={8}>
              <Col lg={8}>
                <ControlLabel>Search</ControlLabel>
                <SearchInput placeholder='Name, Acc Ref' onChange={(v) => this.onSearch(v)} isSearching={searching} />
              </Col>
              <Col lg={5}>
                <ControlLabel>View</ControlLabel>
                <Radio.Group defaultValue={this.getTimesheetView()} onChange={(v) => this.onChangeView(v)}>
                  <Radio.Button value='client'> Participant </Radio.Button>
                  <Radio.Button value='employee'> Employee </Radio.Button>
                </Radio.Group>
              </Col>
              <Col lg={8}>
                <ControlLabel>Status</ControlLabel>
                <Radio.Group defaultValue='all' onChange={(v) => this.onFilter(v)}>
                  <Radio.Button value='all'> All </Radio.Button>
                  <Radio.Button value='approved'>Complete</Radio.Button>
                  <Radio.Button value='review'>Incomplete</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </Page.Filter>

          <div className='payroll'>
            <Skeleton loading={loading} active>
              <List cols={columns} rows={list} />
            </Skeleton>
          </div>

          <Pager
            size={pageSize}
            total={total}
            totalText={`Total ${total} ${this.isEmployeeView() ? 'employee' : 'client'}${total > 1 ? 's' : ''}`}
            current={currentPage}
            onChange={this.changePage}
            style={{ marginTop: '15px' }}
          />
        </Page.Content>
      </Page.Body>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchTimesheets({ currentPage, filter, searchText, sort })
  }

  fetchTimesheets = async ({ loading = true, currentPage = 1, filter = {}, sort = {}, searchText }) => {
    try {
      const { fetchTimesheets } = this.props
      this.setState({ currentPage, loading: true })
      fetchTimesheets({ loading, currentPage, pageSize, filter, sort, searchText, view: this.getTimesheetView() })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load employees successfully. Please try again later.')
    }
  }

  fetchTimesheetSummary = async () => {
    const { match, fetchTimesheetSummary } = this.props
    const { params } = match
    const { id } = params

    try {
      fetchTimesheetSummary({ id, view: this.getTimesheetView() })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load employees successfully. Please try again later.')
    }
  }
}

const mapDispatchToProps = {
  fetchTimesheets,
  fetchTimesheetSummary
}

const mapStateToProps = (state) => {
  return { ...state.Payroll }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Payroll)
